import React from 'react';
import { Spring, animated } from 'react-spring';
import Noise from '../../components/Noise';
import ContactForm from './ContactForm';

import styles from './style.css';

const Contact = () => (
  <div className={styles.contact}>
    <Noise />
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {style => (
        <animated.div style={style} className={styles.contact__content}>
          <address className={styles.contact__address}>
            <a
              href="https://goo.gl/maps/SKB89v2PdaR2"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contact__address__main}
            >
              <strong>Work in Progress SRL</strong>
              <br />
              2 Emil Isac, Ap. 9A
              <br />
              400023 Cluj-Napoca
              <br />
              Cluj, Romania
            </a>
            <a
              href="https://w3w.co/examples.improve.design"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contact__address__w3w}
            >
              <svg viewBox="0 0 32 32">
                <path
                  fill="currentColor"
                  d="M10.7 4h2L4 28H2l8.7-24zm9 0h2L13 28h-2l8.7-24zm9 0h2L22 28h-2l8.7-24z"
                />
              </svg>
              examples.improve.design
            </a>
            <a href="tel:+40364141876" className={styles.contact__address__tel}>
              +40 364 141 876
            </a>
          </address>
          <div className={styles.contact__form__wrapper}>
            <div className={styles.contact__form__wrapper__inner}>
              <ContactForm />
              <div className={styles.contact__form__recaptcha}>
                This site is protected by reCAPTCHA and the Google{' '}
                <a href="https://policies.google.com/privacy">Privacy Policy</a>{' '}
                and{' '}
                <a href="https://policies.google.com/terms">Terms of Service</a>{' '}
                apply.
              </div>
            </div>
          </div>
        </animated.div>
      )}
    </Spring>
  </div>
);

export default Contact;
